const cities = [
  { name: 'Campbell', primary: true },
  { name: 'San Jose', primary: true },
  { name: 'Santa Clara', primary: true },
  { name: 'Mountain View', primary: true },
  { name: 'Palo Alto', primary: false },
  { name: 'Los Altos', primary: false },
  { name: 'Milpitas', primary: false },
  { name: 'Sunnyvale', primary: false },
  { name: 'Cupertino', primary: false },
  { name: 'Los Gatos', primary: false },
  { name: 'Saratoga', primary: false },
  { name: 'Surrounding Bay Area', primary: false },
];

export default function ServiceAreas() {
  return (
    <section id="service-areas" className="py-28" style={{ background: '#f8f8f5', borderTop: '1px solid #eeede8' }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10">

        {/* Header */}
        <div className="text-center mb-16">
          <span
            className="text-[#d4af37] text-[10px] uppercase tracking-[4px] font-bold block mb-5"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Service Areas
          </span>
          <h2
            className="font-black text-[#0d1a27] leading-tight mb-5"
            style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 'clamp(2rem, 4vw, 3.2rem)', letterSpacing: '-0.02em' }}
          >
            Proudly Serving
            <br />
            <span className="text-[#d4af37]">Campbell &amp; the South Bay</span>
          </h2>
          <p
            className="text-[#777] text-[15px] leading-[1.8] max-w-xl mx-auto"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Based in Campbell, CA — we serve homeowners and businesses throughout the South Bay and greater Bay Area. Our local expertise means roofing and solar systems built for Bay Area climate conditions.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-12 items-start">

          {/* Left — cities + info */}
          <div className="w-full lg:w-[36%]">
            {/* City tags */}
            <div className="flex flex-wrap gap-2.5 mb-10">
              {cities.map((city, idx) => (
                <span
                  key={idx}
                  className="text-sm px-4 py-2 rounded-full font-medium transition-colors"
                  style={{
                    fontFamily: "'Inter', sans-serif",
                    background: city.primary ? '#0d1a27' : 'white',
                    color: city.primary ? 'white' : '#555',
                    border: city.primary ? 'none' : '1px solid #e8e8e4',
                  }}
                >
                  {city.name}
                </span>
              ))}
            </div>

            {/* Contact info card */}
            <div className="bg-white rounded-lg p-6 border border-[#eeede8] flex flex-col gap-5">
              <div className="flex items-start gap-4">
                <div
                  className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0"
                  style={{ background: 'rgba(212,175,55,0.1)' }}
                >
                  <i className="ri-map-pin-2-line text-[#d4af37] text-lg"></i>
                </div>
                <div>
                  <p className="text-[#0d1a27] font-bold text-sm" style={{ fontFamily: "'Montserrat', sans-serif" }}>Our Office</p>
                  <p className="text-[#777] text-sm mt-0.5 leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
                    2959 Winchester Blvd Ste 102a<br />
                    Campbell, CA 95008
                  </p>
                </div>
              </div>

              <div style={{ borderTop: '1px solid #f0f0ec' }}></div>

              <div className="flex items-start gap-4">
                <div
                  className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0"
                  style={{ background: 'rgba(212,175,55,0.1)' }}
                >
                  <i className="ri-phone-fill text-[#d4af37] text-lg"></i>
                </div>
                <div>
                  <p className="text-[#0d1a27] font-bold text-sm" style={{ fontFamily: "'Montserrat', sans-serif" }}>Call Us</p>
                  <a
                    href="tel:4086280065"
                    className="text-[#d4af37] font-black text-base hover:text-[#c4a030] transition-colors"
                    style={{ fontFamily: "'Montserrat', sans-serif" }}
                  >
                    (408) 628-0065
                  </a>
                </div>
              </div>

              <div style={{ borderTop: '1px solid #f0f0ec' }}></div>

              <div className="flex items-start gap-4">
                <div
                  className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0"
                  style={{ background: 'rgba(212,175,55,0.1)' }}
                >
                  <i className="ri-time-line text-[#d4af37] text-lg"></i>
                </div>
                <div>
                  <p className="text-[#0d1a27] font-bold text-sm" style={{ fontFamily: "'Montserrat', sans-serif" }}>Hours</p>
                  <p className="text-[#777] text-sm mt-0.5 leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
                    Mon – Sat: 7:00 am – 6:00 pm<br />
                    Sunday: Closed
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right — Google Map */}
          <div
            className="w-full lg:w-[64%] rounded-lg overflow-hidden border border-[#eeede8]"
            style={{ height: '460px' }}
          >
            <iframe
              title="Shadowfax Roofing & Solar — 2959 Winchester Blvd, Campbell, CA 95008"
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d396.8801294675499!2d-121.955651!3d37.270454!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808e3504dd99fa9d%3A0xb62bb9bce59a526c!2s2959%20Winchester%20Blvd%20%23102a%2C%20Campbell%2C%20CA%2095008!5e0!3m2!1sen!2sus!4v1769073377416!5m2!1sen!2sus"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}
